var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.show ? _c("div", {
    staticClass: "loading-container",
    style: {
      background: _vm.background
    }
  }, [_c("div", {
    staticClass: "loading-wrapper"
  }, [_vm.spin == "loading" ? _c("svg-icon", {
    staticClass: "loading-icon",
    attrs: {
      icon: "loading",
      color: "#3ff9dc",
      size: 25
    }
  }) : _c(_vm.spin + "-spin", {
    tag: "component"
  }), _c("div", {
    staticClass: "text",
    style: {
      color: _vm.textColor
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.text)))])], 1)]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };